<v4-custom-select
  [placeholder]="'placeholder.group_or_type' | translate"
  [textItem]="inputTextView"
  [showTextItem]="inputTextView"
  [(visible)]="isOpen"
>
  <div class="v4-layout-dropdown w-[560px]">
    <div class="v4-filter-list pb-[30px]">
      <div class="v4-filter-item">
        <div
          class="v4-filter"
          [class.selected]="type === 'group'"
          (click)="onTypeChange('group')"
        >
          <!-- 房间分组 -->
          {{ "component.search.house_group" | translate }}
        </div>
      </div>
      <div class="v4-filter-item">
        <div
          class="v4-filter"
          [class.selected]="type === 'type'"
          (click)="onTypeChange('type')"
        >
          <!-- 房型 -->
          {{ "word.house_type" | translate }}
        </div>
      </div>
    </div>
    <ng-container *ngIf="listOfPanelItem.length !== 0">
      <div class="v4-option-list pb-[30px]">
        <div class="v4-option-item" *ngFor="let item of listOfPanelItem">
          <div
            class="v4-option"
            [class.selected]="selected.has(item.value)"
            (click)="onItemSelect(item)"
          >
            {{ item.label }}
          </div>
        </div>
      </div>
      <div class="flex flex-row items-center justify-between">
        <a class="text-primary" href="javascript:void()" (click)="onReset()">
          <!-- 重置选项 -->
          {{ "word.reset_settings" | translate }}
        </a>
        <div>
          <button nz-button nzSize="large" class="mr-3" (click)="onCancel()">
            {{ "word.cancel" | translate }}
          </button>
          <button nz-button nzType="primary" nzSize="large" (click)="onSave()">
            {{ "word.confirm" | translate }}
          </button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="listOfPanelItem.length === 0">
      <div *ngIf="selectType === 'type'" class="none">
        <img class="host-no-data-img-small" src="/assets/icon/no_data.png" />
        <p class="title">
          <!-- 暂无房型 -->
          {{ "house_price.no_house_type" | translate }}
        </p>
        <p class="text">
          <!-- 请前往房间页面创建 -->
          {{ "house_price.to_create_house" | translate }}
        </p>
      </div>
      <div *ngIf="selectType === 'group'" class="none">
        <img class="host-no-data-img-small" src="/assets/icon/no_data.png" />
        <p class="title">
          <!-- 暂无分组 -->
          {{ "house.no_group" | translate }}
        </p>
      </div>
    </ng-container>
  </div>
</v4-custom-select>
